import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=cdbe6042&"
import script from "./sheet.vue?vue&type=script&lang=js&"
export * from "./sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbe6042')) {
      api.createRecord('cdbe6042', component.options)
    } else {
      api.reload('cdbe6042', component.options)
    }
    module.hot.accept("./sheet.vue?vue&type=template&id=cdbe6042&", function () {
      api.rerender('cdbe6042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/sheet.vue"
export default component.exports